<script lang='ts'>
import { toRefs, reactive, defineComponent, computed, PropType } from '@vue/composition-api';
import { NotificationProviderSettings } from '@/store/global/notification-settings/types';
import { useNotificationSettingsStore } from '@/store/global/notification-settings';

interface IProps {
    model: NotificationProviderSettings;
    label: string;
    disabled: string[];
}

const SettingsBlockRow = defineComponent({
    name: 'SettingsBlockRow',
    props: {
        model: Object as PropType<NotificationProviderSettings>,
        label: String,
        disabled: Array as PropType<string[]>,
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props: IProps, ctx) {
        const store = useNotificationSettingsStore();

        const state = reactive({
            slackIsConnected: computed(() => store.state.slackIsConnected),
        });

        const isDisabled = (str: string) => (props.disabled ? props.disabled.includes(str) : false);

        return {
            state,
            isDisabled,
            ...toRefs(state),
        };
    },
});

export default SettingsBlockRow;
</script>

<template>
  <div class="d-flex">
    <v-checkbox
      v-model="model.inApp"
      class="mt-0"
      hide-details
      dense
      :disabled="isDisabled('inApp')"
    />
    <v-checkbox
      v-if="state.slackIsConnected"
      v-model="model.slack"
      class="mt-0"
      hide-details
      dense
      :disabled="isDisabled('slack')"
    />
    <v-checkbox
      v-model="model.email"
      class="mt-0"
      hide-details
      dense
      :disabled="isDisabled('email')"
    />
    <div v-if="label" class="pt-1">
      {{ label }}
    </div>
    <slot name="label" />
  </div>
</template>

<style lang='scss' scoped></style>